var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-sm block text-center py-3"},[_c('span',{staticClass:"text-yellow-mm-600"},[_vm._v(_vm._s(_vm.remaining))]),_vm._v(" / "+_vm._s(_vm.quota)+" klokker tilgjengelig\n")])}
var staticRenderFns = []

export { render, staticRenderFns }